import { inject, Injectable } from '@angular/core';
import { AuthService } from '@evc/platform';
import { Observable, of } from 'rxjs';

import { ConfigService } from '../config';
import { AuthenticationService } from './authentication.interface';

@Injectable({
  providedIn: 'root',
})
export class EvcAuthenticationService implements AuthenticationService {
  private readonly _authService = inject(AuthService);
  private readonly _config = inject(ConfigService);

  public async initialize(): Promise<void> {
    if (this._config.isCloudConnected) {
      await this._authService.init();
    }
  }

  public logout(): void {
    this._authService.logout({ postLogoutRedirectUri: window.location.origin });
  }

  public isUserLoggedIn(): Observable<boolean> {
    return of(this._authService.isAuthenticated() === true);
  }
}
